import { useAsyncData } from 'modules/core/hooks/useAsyncData'

import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'
import type SubscriptionAddon from 'modules/billing/store/models/SubscriptionAddon'

export interface UseFetchDataType {
  loading: boolean
  isNotFound: boolean
  subscriptionAddon: SubscriptionAddon | null | undefined
}

const useFetchData = (addonId?: string): UseFetchDataType => {
  const { loading } = useAsyncData(() => subscriptionAddons.fetch(), [])
  const subscriptionAddon = subscriptionAddons.find({ id: addonId })
  const isNotFound = !addonId || loading ? false : !subscriptionAddon

  return {
    loading,
    isNotFound,
    subscriptionAddon,
  }
}

export default useFetchData
